import { END_POINTS } from '../constants/urls';
import emptySplitApi from '../utils/rtk';

interface CommonResponseType {
  statusCode: number;
  message: string;
}

export const BulkUploadApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    BulkUpload: builder.mutation<
      CommonResponseType, { data?: any }
    >({
      query: (body) => ({
        url: END_POINTS.bulkUpload,
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const {
  useBulkUploadMutation
} = BulkUploadApi;
